"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var NotificationsSidebar_1 = __importDefault(require("./components/NotificationsSidebar"));
var StudentNotificationsInbox_1 = __importDefault(require("./components/StudentNotificationsInbox"));
var useNotificationsState_1 = __importDefault(require("./hooks/useNotificationsState"));
var useUnreadCount_1 = __importDefault(require("./hooks/useUnreadCount"));
var bootstrap_1 = require("./bootstrap");
var notificationsStore_1 = require("./storage/notificationsStore");
var preferencesStore_1 = require("./storage/preferencesStore");
var mountIsland_1 = require("../mountIsland");
__exportStar(require("./api"), exports);
var inbox = (0, bootstrap_1.bootInboxFromDOM)();
if (inbox) {
    (0, notificationsStore_1.initNotifications)(inbox);
    (0, notificationsStore_1.initUnreadCount)({ userId: inbox.userId, unreadCount: inbox.unreadCount }); // for sidebar
}
var kinds = (0, bootstrap_1.bootKindsFromDOM)();
if (kinds) {
    (0, preferencesStore_1.initKinds)(kinds);
}
var notificationsContainer = document.getElementById('notifications-container');
var notificationsSidebar = document.getElementById('notifications-vertical-sidebar');
var InboxRoot = function () {
    var state = (0, useNotificationsState_1.default)();
    return react_1.default.createElement(StudentNotificationsInbox_1.default, __assign({}, state));
};
var NotificationsSidebarWithCount = function () {
    var unreadCount = (0, useUnreadCount_1.default)();
    return react_1.default.createElement(NotificationsSidebar_1.default, { unreadCount: unreadCount });
};
if (notificationsContainer) {
    (0, mountIsland_1.mountIsland)(notificationsContainer, react_1.default.createElement(InboxRoot, null));
}
if (notificationsSidebar) {
    (0, mountIsland_1.mountIsland)(notificationsSidebar, react_1.default.createElement(NotificationsSidebarWithCount, null));
}
